// Drives the cart-drawer "Andre købte også" recommendations.
//
// 1. Load kick: Dawn's <product-recommendations> only fetches via an
//    IntersectionObserver, which never fires while the drawer is rendered
//    off-canvas (a hidden ancestor never intersects). When the drawer gains
//    `.active` we call the element's own loadRecommendations() so the cards
//    populate on open.
// 2. Arrows: mouse users don't discover horizontal scroll, so the desktop
//    carousel gets prev/next buttons that page the track and enable/disable at
//    the ends. Mobile keeps native swipe (arrows hidden via CSS).
//
// Cart updates recreate the element, so everything re-runs on subtree changes;
// per-element flags prevent duplicate work.
(function () {
  const SELECTOR = 'product-recommendations.cart-recommendations';

  // Every cart repaint recreates the element EMPTY (the drawer section render never
  // carries the cards — they only exist in the recommendations-route fragment), so the
  // carousel blinked out for a full network round-trip on each mutation. Restore the
  // last loaded markup for the same seed product synchronously, then let the normal
  // load revalidate it in place: the server excludes in-cart products, so the cached
  // copy can be one mutation stale, and the refresh swaps identical-or-updated content
  // without ever showing the empty gap.
  const loadedMarkup = new Map();

  function kick(el) {
    if (el.dataset.cartRecKicked === 'true') return;
    if (el.innerHTML.trim().length > 0) return;
    const productId = el.dataset.productId;
    if (!productId) return;
    const cached = loadedMarkup.get(productId);
    if (cached) {
      el.innerHTML = cached;
      el.classList.add('product-recommendations--loaded');
    }
    if (typeof el.loadRecommendations !== 'function') return;
    el.dataset.cartRecKicked = 'true';
    el.loadRecommendations(productId);
  }

  function remember(el) {
    const productId = el.dataset.productId;
    if (!productId) return;
    if (!el.querySelector('.cart-recommendations__track')) return;
    loadedMarkup.set(productId, el.innerHTML);
  }

  function initArrows(el) {
    const track = el.querySelector('.cart-recommendations__track');
    if (!track || track.dataset.cartRecArrows === 'true') return;
    const prev = el.querySelector('[data-cart-rec-prev]');
    const next = el.querySelector('[data-cart-rec-next]');
    if (!prev || !next) return;
    track.dataset.cartRecArrows = 'true';

    const page = () => Math.max(track.clientWidth * 0.85, 120);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  function enhance(drawer) {
    if (!drawer.classList.contains('active')) return;
    drawer.querySelectorAll(SELECTOR).forEach((el) => {
      kick(el);
      remember(el);
      initArrows(el);
    });
  }

  function observe(drawer) {
    if (drawer.dataset.cartRecObserved === 'true') return;
    drawer.dataset.cartRecObserved = 'true';
    new MutationObserver(() => enhance(drawer)).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    enhance(drawer);
  }

  function init() {
    document.querySelectorAll('cart-drawer').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
